export default [
  { label: 'Sports', value: 'sports' },
  { label: 'Visual Arts, Music & Theater', value: 'music' },
  { label: 'Community Service', value: 'community' },
  { label: 'Job/Internship', value: 'job' },
  { label: 'School Clubs', value: 'clubs' },
  { label: 'Student Government', value: 'government' },
  { label: 'Other', value: 'other' },
];
